import type { CityConfig } from "@/pages/city-template/types";

export const johnstonConfig: CityConfig = {
  city: "Johnston",
  state: "Rhode Island",
  stateAbbr: "RI",
  slug: "johnston",
  route: "/cities/johnston",
  title: "Emergency & Expedited Passport Johnston, RI | Same Day Passport Services",
  metaDescription:
    "Emergency passport Johnston RI — same day, 24-hour, and 3-5 day expedited passport processing. Fast Passport Center is a registered courier serving Johnston, Graniteville, Simmonsville, and all Providence County. Avoid the 8-11 week wait.",
  h1: "Emergency & Expedited Passport Services in Johnston, RI",
  heroSubtitle:
    "Johnston sits at the heart of Providence County — and travelers here need service that moves just as fast. Fast Passport Center delivers emergency passports as quick as 24 hours, with 3-5 day expedited service for Johnston, Graniteville, Simmonsville, and all of Providence County.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Scenic%20suburban%20view%20of%20Johnston%20Rhode%20Island%20with%20rolling%20green%20hills%20and%20residential%20neighborhoods%2C%20warm%20golden%20afternoon%20light%2C%20classic%20New%20England%20suburban%20charm%2C%20clean%20modern%20travel%20photography%20composition%2C%20no%20text%20overlay&width=1600&height=700&seq=ri-john-hero-001&orientation=landscape",
  heroImageAlt: "Scenic suburban view of Johnston Rhode Island",
  geoPosition: "41.8301; -71.4918",
  geoPlacename: "Johnston, Rhode Island, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Thomas P. O'Neill Jr. Federal Building, 10 Causeway Street, Boston, MA 02222",
    distance: "~48 miles from Johnston",
  },
  nearbyCitiesZips: [
    { name: "Johnston", zips: "02919" },
    { name: "Providence", zips: "02901-02912, 02918, 02940" },
    { name: "Cranston", zips: "02905-02907, 02910, 02920-02921" },
    { name: "Warwick", zips: "02886-02889, 02818" },
    { name: "Pawtucket", zips: "02860-02862" },
    { name: "North Providence", zips: "02904, 02911" },
    { name: "East Providence", zips: "02914-02916" },
    { name: "West Warwick", zips: "02893" },
    { name: "Coventry", zips: "02816, 02827" },
    { name: "Smithfield", zips: "02917" },
    { name: "Woonsocket", zips: "02895" },
    { name: "Cumberland", zips: "02864, 02827" },
    { name: "Lincoln", zips: "02865" },
    { name: "Central Falls", zips: "02863" },
    { name: "Scituate", zips: "02857, 02815" },
    { name: "Glocester", zips: "02814, 02859" },
    { name: "Foster", zips: "02825" },
    { name: "Burrillville", zips: "02830, 02858" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Johnston travelers with urgent departures — same day service available for life-or-death situations.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with reserved agency submission slots.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Serving All of Johnston",
      desc: "Graniteville, Simmonsville, Thornton, Belknap, Hughesdale — we cover every Johnston neighborhood.",
    },
  ],
  testimonials: [
    {
      name: "James P.",
      location: "Johnston, RI",
      rating: 5,
      text: "I needed an emergency passport from Johnston for a last-minute business trip. Fast Passport Center had it ready in 4 days. The agent walked me through every form.",
      service: "Emergency Passport",
    },
    {
      name: "Susan K.",
      location: "Graniteville, Johnston, RI",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center. Chose the 5-day option and had it back in 3 days. They caught a small photo issue before it became a problem.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas M.",
      location: "Simmonsville, Johnston, RI",
      rating: 5,
      text: "First-time passport for my son. The agent explained the two-parent rule and helped us get the consent forms right. Processed in 5 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "john-1",
      name: "Johnston Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1275 Hartford Avenue",
      city: "Johnston",
      state: "RI",
      zip: "02919",
      phone: "401-231-6340",
      hours: "Mon-Fri 8:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Central Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "john-2",
      name: "Cranston Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "1055 Park Avenue",
      city: "Cranston",
      state: "RI",
      zip: "02910",
      phone: "401-941-4340",
      hours: "Mon-Fri 8:00 AM - 4:30 PM, Sat 9:00 AM - 12:00 PM",
      distance: "~3 miles from Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Nearby alternative for Johnston residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "john-3",
      name: "RI DMV — Cranston",
      type: "State DMV / ID Services",
      address: "600 New London Ave",
      city: "Cranston",
      state: "RI",
      zip: "02920",
      phone: "401-462-4368",
      hours: "Mon-Fri 8:30 AM - 3:15 PM",
      distance: "~4 miles from Johnston",
      website: "https://www.ri.gov/",
      websiteLabel: "State of Rhode Island",
      notes: "Main Rhode Island DMV office. Accepts walk-ins but appointments are strongly recommended. REAL ID and driver's license services available.",
      icon: "ri-car-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Johnston, RI?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Johnston residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Johnston?",
      a: "The Johnston Post Office at 1275 Hartford Avenue offers passport acceptance services by appointment. The Cranston Post Office at 1055 Park Avenue is also nearby (~3 miles) and accepts passport applications. First-time applicants and those not eligible for mail-in renewal must apply in person at these facilities. Fast Passport Center guides you through the acceptance clerk process.",
    },
    {
      q: "Can I get same-day passport photos in Johnston, RI?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations near Johnston in Cranston and Providence. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements before submission.",
    },
    {
      q: "How much does an expedited passport cost in Johnston?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Johnston passport needs.",
    },
    {
      q: "Do I need to drive to the Boston Passport Agency from Johnston?",
      a: "No — if you use Fast Passport Center, you do not need to visit the Boston Passport Agency at all. As a registered courier, we handle the agency submission for you. The only reason to visit the Boston agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Johnston, Rhode Island?",
      a: "The fastest way to renew a passport in Johnston is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Johnston, RI?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Johnston and all of Providence County. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Johnston, RI?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Johnston. We serve Johnston and all of Rhode Island through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Johnston / Cranston", address: "various CVS locations near Johnston in Cranston and Providence", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Johnston / Cranston", address: "various Walgreens locations near Johnston", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Cranston", address: "various UPS Store locations in Cranston (~3 mi from Johnston)", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Providence", address: "various FedEx Office locations in Providence (~6 mi from Johnston)", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart — Cranston", address: "various Walmart locations in Cranston", hours: "Mon-Sun 7:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "RI DMV — Cranston",
      address: "600 New London Ave, Cranston, RI 02920",
      hours: "Mon-Fri 8:30 AM - 3:15 PM",
      note: "Main Rhode Island DMV office. Accepts walk-ins but appointments are strongly recommended. REAL ID and driver's license services.",
      featured: true,
    },
    {
      name: "RI DMV Express — Pawtucket",
      address: "1250 Elmwood Ave, Cranston, RI 02910",
      hours: "Mon-Fri 8:30 AM - 3:15 PM",
      note: "Express DMV services for license renewals and REAL ID applications.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PVD",
      name: "T.F. Green Airport",
      distance: "~10 miles from Johnston",
      address: "2000 Post Rd, Warwick, RI 02886",
      note: "Rhode Island's primary airport, just minutes from Johnston. Serves domestic destinations and limited international connections.",
      flightUrl: "https://www.pvdairport.com/",
      flightLabel: "T.F. Green Airport",
      featured: true,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "~52 miles from Johnston",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and worldwide destinations. Johnston travelers often use Logan for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan International",
      featured: false,
    },
    {
      code: "BDL",
      name: "Bradley International Airport",
      distance: "~68 miles from Johnston",
      address: "Schoephoester Rd, Windsor Locks, CT 06096",
      note: "Connecticut's major airport with domestic and some international service. Alternative option for Johnston-area travelers.",
      flightUrl: "https://www.bradleyairport.com/",
      flightLabel: "Bradley International",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Johnston travelers with urgent departures within 24 hours to 2 weeks. Reserved agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Johnston residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Johnston residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Johnston residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Johnston, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Johnston residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Johnston travelers with immediate departure needs." },
    { name: "Passport Renewal", description: "Fast passport renewal for Johnston residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Johnston residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Johnston residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Johnston." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Johnston." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Johnston travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Johnston travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Johnston-area team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application with reserved agency processing slots.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Johnston address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Providence", route: "/cities/providence" },
    { name: "Warwick", route: "/cities/warwick" },
    { name: "Cranston", route: "/cities/cranston" },
    { name: "Pawtucket", route: "/cities/pawtucket" },
    { name: "Newport", route: "/cities/newport-ri" },
    { name: "East Providence", route: "/cities/east-providence" },
    { name: "Woonsocket", route: "/cities/woonsocket" },
    { name: "North Providence", route: "/states/rhode-island" },
    { name: "West Warwick", route: "/cities/west-warwick" },
    { name: "Coventry", route: "/cities/coventry" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Johnston and all of Rhode Island as a remote courier service. We do not have a physical office in Johnston, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Johnston, RI area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to all Johnston neighborhoods and surrounding Rhode Island communities. From Graniteville to Simmonsville, Thornton to Belknap — we serve every Johnston neighborhood with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Johnston and all surrounding Rhode Island communities. Whether you're near the Providence border or in a nearby suburb, our expedited passport services are available to you with the same speed and reliability.",
  howItWorksIntro:
    "Our Johnston customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Johnston travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Johnston and Providence County travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Johnston, RI. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/rhode-island",
  statePageName: "Rhode Island Passport Services",
};

export default johnstonConfig;